import * as Sentry from "@sentry/react";

import { getEnvironment } from "../functions/functions";

const { isProductionEnv, env } = getEnvironment();

if (isProductionEnv) {
  // Default value for sendDefaultPii is false. It does not allow to collect IP address or other user data.
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracesSampleRate: 1.0,
    environment: env,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event) {
      // This ensures no IP or user-identifiable data is included
      if (event.user) {
        delete event.user.ip_address;
        delete event.user.id;
        delete event.user.email;
        delete event.user.username;
      }
      return event;
    },
    replaysSessionSampleRate: 0.1, // 10% of sessions
    release: import.meta.env.VITE_VERSION, // Set release version (helps with tracking issues across deployments)
  });
}
